import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "@/contexts/AuthContext";
import PWAInstallPrompt from "@/components/feature/PWAInstallPrompt";
import FloatingInstallButton from "@/components/feature/FloatingInstallButton";
import MobileBottomNav from "@/components/feature/MobileBottomNav";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AuthProvider>
          <AppRoutes />
          <MobileBottomNav />
          <PWAInstallPrompt />
          <FloatingInstallButton />
        </AuthProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
